import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  Router,
  Route,
  ActivatedRoute
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { GutachtenService } from '../../../api/services/gutachten.service';
import { GutachtenDisplayModel } from '../../../api/models/ace/xFound/Portal/Core/CAQ/Models/gutachten-display-model';
import { StammdatenService } from '@/core/services/stammdaten.service';
import { DocumenttypeDisplayModel, InfotextDisplayModel } from '@/api/model-index';
import { PortalContextService } from '@/core/services/portal-context.service';

@Injectable({
  providedIn: 'root'
})
export class ReviewResolver implements Resolve<GutachtenDisplayModel> {
  constructor(protected gutachtenService: GutachtenService, protected stammdatenService: StammdatenService, protected portalContextService: PortalContextService) {
    //
  }

  /**
   * Get all applications containing projects and projectideas.
   * 
   * @param route ActivatedRouteSnapshot
   * @param state RouterStateSnapshot
   * @returns Observable<BewerbungListDisplayModel>
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<GutachtenDisplayModel> {
    let gutachtenId = route.params['id'];


    if (this.portalContextService.CurrentGutachten && this.portalContextService.CurrentGutachten.gutachtenId == gutachtenId)
      return of(this.portalContextService.CurrentGutachten);

    return this.gutachtenService.apiGutachtenGet({ gutachtenId: gutachtenId }).pipe(map(response => {
      this.portalContextService.CurrentGutachten = response;
      if (response.anfrage) {
        this.portalContextService.CurrentAnfrage =  Object.assign({}, response.anfrage);
        this.portalContextService.CurrentAnfrage.attachments = null;
      }

      this.addDocumentTypeInfotext(response.anfrage?.attachments?.map(attachment => attachment.documententyp));
      return response;
    }));
  }

  addDocumentTypeInfotext(documentTypes: (DocumenttypeDisplayModel | undefined)[] | undefined) {
    documentTypes?.filter(documentType => documentType?.infotext?.find(infotext => infotext.text && infotext.text.length > 0)).forEach(documentType => {
      let infotext = new InfotextDisplayModel();
      infotext.schluessel = 'attachments' + documentType?.documenttypeId;
      infotext.beschreibung = documentType?.infotext;
      infotext.name = documentType?.name;
      this.stammdatenService.InfoTexte?.setValue(infotext.schluessel, infotext);
    })
  }
}
